"use strict";

/**
 * @generated SignedSource<<b642b63dd248898acf28976ddd98629e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useClientPreferences_ClientPreferences",
  "selections": [{
    "kind": "ClientExtension",
    "selections": [{
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredSupplierId",
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "concreteType": "DiscardedItem",
      "kind": "LinkedField",
      "name": "discardsBin",
      "plural": true,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiryTS",
        "storageKey": null
      }],
      "storageKey": null
    }]
  }],
  "type": "ClientPreferences",
  "abstractKey": null
};
node.hash = "5ed198d3f247bfcd4a08fdb46fc8373d";
export default node;